var addValidate = false;
var i18n = require('i18n');
var util = require('../../app/util');
require('../../components/tag');
var doAjax = require('../topic/ajax');
var pageConfig = window.pageConfig;


var editorId = 'add-topic';
var addTopicLayer = require('../../app/editorLayer.html');
var topicType = JSON.parse(JSON.stringify(pageConfig.topicType));
if (!pageConfig.admin) {
  delete topicType.notice;
}
var html = addTopicLayer({
  id: editorId,
  title: i18n('add.topic'),
  addTitle: true,
  topicType: util.toArray(topicType),
  tinymce: true,
  markdown: true,
  markcheck: true,
  lines: 18
});
var bugHtml = `<p>1. 环境(测试环境 / 生产环境)</p><p><br>2.&nbsp; 浏览器类型 (chrome / ie11 / firfox / safari)</p><p><br>3. 操作系统类型 (macOS / linux / windows)</p><p><br></p><p>4. 工作台配置<br>4.1&nbsp; 流程图(请将截图贴到下方)</p><p><br>4.2 数据源配置(请将代码贴到下方)</p><p><br></p><p>5. 运行时信息<br>5.1&nbsp; 预览界面-顶部工具栏-控制台面板输出的SQL、参数或过程执行结果 (测试环境提供)<br></p><p><br></p><p>5.2 界面提示的相关错误文本<br></p><p><br></p><p>5.3 桥窗口输出日志内容 (测试环境提供)<br></p><p><br></p><p>5.4 bodhi-app/logs/app.log 日志内容(生产环境提供)</p><p><br></p><p>6. 具体的重现问题步骤:</p><p><br></p>`




$('body').append(html);
$('.add-topic-layer').modal({
  closable: false,
  refresh: false,
  onHidden: function () {
    var layer = $('.add-topic-layer');

    layer.find('[name=title]').val('');
    layer.find('.tab-list').find('.active').removeClass('active');
    layer.find('.tab-list').find('.item:first').addClass('active');
    tinyMCE.get('tinymce-' + editorId).setContent('');
    layer.find('.markdown-editor').val('');
    $('input[name=tags]').importTags();
    debugger
    addTip.hide();
  }
});
$('.add-topic-layer .tab-list').on('click', '.item', function () {
  $(this).parent().find('.active').removeClass('active');
  $(this).addClass('active');
}).on('keyup', '.item', function (e) {
  if (e.keyCode === 32) {
    $(this).parent().find('.active').removeClass('active');
    $(this).addClass('active');
  }
});

var addTip = $('.add-tip');
$('.add-topic-layer .tab-list').on('click', 'a', function (e) {
  var target = $(e.currentTarget);
  if (target.data('type') == 'bug' || target.data('type') == 'question') {
    tinyMCE.activeEditor.setContent(bugHtml, { format: "html"});
    addTip.show()
  } else {
    tinyMCE.activeEditor.setContent('');
    addTip.hide();
  }  
});

module.exports = function (success) {
  if (addValidate) {
    return;
  }
  addValidate = true;

  $.fn.form.settings.rules.tagsLength = function(value, aux, errors) {
    value = value.trim();
    return value.length < pageConfig.tags.length;
  };
  $.fn.form.settings.rules.tagsCount = function(value, aux, errors) {
    value = value.trim();
    return value.split(',').length < pageConfig.tags.count;
  };
  var layer = $('.add-topic-layer');
  layer.form({
    inline: true,
    keyboardShortcuts: false,
    fields: {
      name: {
        identifier: 'title',
        rules: [{
          type   : 'empty',
          prompt : i18n('tip.input.title')
        },{
          type   : 'maxLength[' + pageConfig.topicTitle.max + ']',
          prompt : i18n('tip.title.name.length', {min: pageConfig.topicTitle.min, max: pageConfig.topicTitle.max})
        },{
          type   : 'minLength[' + pageConfig.topicTitle.min + ']',
          prompt : i18n('tip.title.name.length', {min: pageConfig.topicTitle.min, max: pageConfig.topicTitle.max})
        }]
      },
      tags: {
        identifier: 'tags',
        rules: [{
          type: 'tagsLength',
          prompt: i18n('tags.length', {max: pageConfig.tags.length})
        }, {
          type: 'tagsCount',
          prompt: i18n('tags.count', {max: pageConfig.tags.length})
        }]
      }
    }, 
    onSuccess: function (e, data) {
      data.type = layer.find('.tab-list .active').data('type');

      if (pageConfig.topicType && !data.type) {
        util.show(i18n('topic.type'))
        return
      }
      data.editorType = layer.find('input[name=editorType]').prop('checked') ? 'markdown' : 'html';

      var validate = pageConfig.topicContent;
      if (data.editorType === 'html') {
        data.content = tinyMCE.activeEditor.getContent({ format: "raw"});
        var validateContent = tinyMCE.activeEditor.getContent({ format: "text"});

        if (validateContent.length < 5) {
          if (!data.content.match(/<img/)) {
            util.show(i18n('content.length'));
            return;
          }
        } else if (validateContent.length > validate.max) {
          return  util.show(i18n('content.length.max'));
        }
        data.content = data.content.replace('<p>【发帖提示】泛泛地提问可能只能得到泛泛地回答，如亟需帮助，请尽可能地填写以下信息，方便大家更快速地帮助到您</p>', ''); 
      } else {
        data.content = data.markdown;
        data.content = data.content.replace(new RegExp('</script>', 'gm'), '&lt;/script>');
        if (data.content.length < 5) {
          util.show(i18n('content.length'));
          return;
        } else if (data.content.length > validate.max) {
          return  util.show(i18n('content.length.max'));
        }
      }


      data.markdown = undefined;
      data.editor = undefined;
      
      //////data.content.lenth pure text check 

      data.content = data.content.replace(/data-mce-src="[^"]+"/g, '');
      util.uploadImage(data.content, data.editorType, function (content) {
        data.content = content || data.content;
        data.content = data.content.replace(/blob:https:\/\/forum\.(enhancer|wuyuan)\.io\/[^'"]+/g, '');
        doAjax('add', data, function (res) {
          layer.find('.close').click();
          success(res.data, data);
        });
      });
    }
  });

  layer.find('.actions .button').on('keyup', function (e) {
    if (e.keyCode === 13) {
      layer.submit();
    }
  })

  $('input[name=tags]').tagsInput({
    defaultText: i18n('topic.tag'),
    onChange: function (input) {
    }
  });

  
  require('../../app/markdown');
  require('../../app/switch')(editorId, {
    height: 294,
    addTopic: true
  });   
}



// WEBPACK FOOTER //
// ./src/pages/home/addTopicLayer.js